import styled from "styled-components"

const MenuItemFrame = styled.div`
  /* background-color: #222; */
  width: calc(33.33% - 16px);
  height: 300px;
  margin: 0px 24px 24px 0px;

  @media (min-width: 1473px) {
    &:nth-child(3n) {
      margin-right: 0px;
    }
  }
  @media (min-width: 921px) and (max-width: 1472px) {
    &:nth-child(3n) {
      margin-right: 0px;
    }
    height: 20vw;
  }
  @media (min-width: 541px) and (max-width: 920px) {
    width: calc(50% - 12px);
    height: 32vw;
    &:nth-child(2n) {
      margin-right: 0px;
    }
  }
  @media (max-width: 540px) {
    width: 100%;
    height: 58vw;
    margin-right: 0px;
  }
  overflow: hidden;
`

const OutFrame = styled.div`
  background-size: cover;
  width: 100%;
  height: 100%;
  &:hover {
    box-shadow: inset 0 0 20rem rgba(0, 0, 0, 0.4);
    transform: scale(1.03, 1.03);
    transition-duration: 0.5s;
  }
`

const TypeFrame = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  &:hover {
    opacity: 0;
  }
`

const MenuTitle = styled.div`
  height: auto;
  padding: 10px;
  margin-top: 30px;
  font-family: "title-font";
  color: #fff;
  text-align: center;
  text-shadow: 0px 0px 15px #000;
  font-size: 3.5rem;
  line-height: 4rem;
  @media (max-width: 920px) {
    font-size: 3rem;
    line-height: 3.5rem;
  }
`

const MenuSub = styled.div`
  margin-top: 0.2rem;
  height: auto;
  font-family: "sub-font";
  /* text-shadow: 0px 0px 15px #000; */
  color: #bbb;
  line-height: 0.7rem;
  font-size: 1.7rem;
  text-align: center;
  @media (max-width: 920px) {
    font-size: 1.5rem;
  }

  margin-bottom: 5rem;
`

function MenuItem({ title, sub, mainBg, menuTrance }) {
  return (
    <MenuItemFrame onClick={menuTrance}>
      <OutFrame style={{ backgroundImage: `url(${mainBg})` }}>
        <TypeFrame>
          <MenuTitle>{title}</MenuTitle>
          <MenuSub>{sub}</MenuSub>
        </TypeFrame>
      </OutFrame>
    </MenuItemFrame>
  )
}

export default MenuItem
